import { render, staticRenderFns } from "./CapacityHistoryModal.vue?vue&type=template&id=a31d45fa&scoped=true"
import script from "./CapacityHistoryModal.vue?vue&type=script&lang=ts"
export * from "./CapacityHistoryModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31d45fa",
  null
  
)

export default component.exports